import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TourStopMapComponent } from './tour-stop-map.component';
import { TourStopMapRoutingModule } from './tour-stop-map-routing.module';
import { SharedModule } from '@shared/shared.module';
import { LoadingTourComponent } from './components/loading-tour/loading-tour.component';
import { TourMapComponent } from './components/tour-map/tour-map.component';
import { LottieModule } from 'ngx-lottie';
import { AngularFireModule } from '@angular/fire';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { LocationPermissionComponent } from '../map/location-permission/location-permission.component';
import { LocationLottieAnimationComponent } from '../location-lottie-animation/location-lottie-animation.component';
import { WelcomeMapComponent } from '../map/welcome-map/welcome-map.component';
import { CityHallModelComponent } from '../city-hall-model/city-hall-model.component';


@NgModule({
  declarations: [
    TourStopMapComponent,
    TourMapComponent,
    LoadingTourComponent,
    LocationPermissionComponent,
    LocationLottieAnimationComponent,
    WelcomeMapComponent,
    CityHallModelComponent
  ],
  imports: [
    CommonModule,
    TourStopMapRoutingModule,
    LottieModule,
    AngularFireModule,
    NgxMapboxGLModule,
    SharedModule
  ],
  exports: [
    TourStopMapComponent,
    TourMapComponent,
    LoadingTourComponent,
    LocationPermissionComponent,
    LocationLottieAnimationComponent,
    WelcomeMapComponent
  ]
})
export class TourStopMapModule { }
